import React, { useRef } from 'react';
import './ScrollDownArrow.css'; // Import CSS for animations

// Reusable ScrollDownArrow component
const ScrollDownArrow = ({ nextSectionClass }) => {
  const arrowRef = useRef(null);

  const scrollToNextSection = () => {
    const snapContainer = document.querySelector('.snap-container');
    const nextSection = document.querySelector(`.${nextSectionClass}`);
  
    if (nextSection && snapContainer) {
      const sectionOffset = nextSection.offsetTop;
      
      // Smoothly scroll inside the .snap-container
      snapContainer.scrollTo({
        top: sectionOffset,
        behavior: 'smooth',
      });
    } else {
      console.log("Next section or snap container not found!");
    }
  };

  return (
    <div className="scroll-down-arrow-container">
      <div
        className="scroll-down-arrow"
        ref={arrowRef}
        onClick={scrollToNextSection}
      >
        &#8595; {/* Downward arrow symbol */}
      </div>
    </div>
  );
};

export default ScrollDownArrow;
